import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { configureWebApi } from './lib/api/configure.js';

import './styles/globals.css';
import './components/primitives/primitives.css';
import './components/feedback/feedback.css';
import './components/form/form.css';
import './components/overlay/overlay.css';
import './components/system/system.css';
import './components/data/data.css';
import './components/status/status.css';
import './components/map/map.css';
import './components/shell/shell.css';
import './components/discovery/discovery.css';
import './pages/pages.css';
import './pages/public/public.css';
import './pages/owner/owner.css';
import './pages/owner/ownerHome.css';
import './pages/offers/commerce.css';
import './pages/operations/operations.css';
import './pages/billing/billing.css';
import './pages/support/support.css';

// TeraAgo — scoped under `.cityload`, so it cannot reach the app above it.
import './cityload/tokens.css';
import './cityload/admin.css';
import './cityload/dashboard.css';
import './cityload/login.css';
import './cityload/partner.css';
import './cityload/fleet.css';

// The API client is platform-agnostic; this supplies the browser's half.
configureWebApi();

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
